import React, { FC } from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { TExploreServicesProps } from './types/exploreOurServices.types';
import { ExploreServicesModel } from './models/exploreOurServices.model';
import ExploreServicesCard from './components/exploreServicesCard';
import StyledLink from '../@shared/styledLink';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import { targetLinkdsk } from '../../utils/targetDskLink';
import useMediaQuery from '../../hooks/useMediaQuery';
import breakpoints from '../../constants/breakpoints.constants';
import './styles.scss';

const ExploreOurServices: FC<TExploreServicesProps> = (props: TExploreServicesProps) => {
  const model = new ExploreServicesModel(props);
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints['tbl-p']}px)`);
  const generateCards = model.cards.map((item, i) => {
    if (i === model.cards.length - 1) {
      item.last = true;
    }
    return <ExploreServicesCard {...item} key={item?.id} cardHeadingTitleTag={model.cardHeadingTitleTag} />;
  });

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  return (
    <>
      <div className="explore-services-wrapper">
        <div className="explore-services">
          {model.title && <Text tag={model.headingTag} field={model.title} className="explore-services__title" />}
          <div className="explore-services__subtitle">
            <StyledLink field={model.link} target={targetLinkdsk(model?.link, isDesktop)} />
          </div>
          <div className="explore-services__cards-wrapper">{generateCards}</div>
        </div>
      </div>
    </>
  );
};

export default ExploreOurServices;
